export default "__VITE_ASSET__CkqlGVIJ__"